<template>
    <div class="app-label">
        <b-form-group  :id="groupId" v-bind="$attrs">
            <template v-if="useLabel" v-slot:label>{{ labelStr }}</template>
            <div :class="useLabel && isUseClassSameAsLabel ? 'input-label-detail' : ''">
                <span v-if="this.thousandSeparator">
                    <app-currency-label :text="inputModel" />
                </span>
                <span v-else-if="type=='generatednumber' && (inputModel == null || inputModel == undefined || inputModel == '')">
                    [Autogenerated]
                </span>
                <span v-else>
                    {{ inputModel }}
                </span>
            </div>
        </b-form-group>
    </div>
</template>
<style lang="scss" scoped>
.app-label{
    .input-label-detail {
        line-height: 1.3 !important;
        height: max-content;
    }
}
</style>

<script>
import moment from 'moment';
export default {
    props: ["model", "id", "name", "thousandSeparator", "label", "enterMethod", "type", "nolabel", "isDate", "isTime", "isDateTime","sameSizeLabelValue"],
    data() {
        return {
            labelStr: this.label,
            inputModel: this.model,
            prefixExist: (this.prefix ? true : false),
            suffixExist: (this.suffix ? true : false),
            groupId : "fieldset-" + this.id,
            feedbackId : "input-" + this.id + "-live-feedback",
            popoverShow: false,
            popoverInputModel: this.model,
            isDateInput: (this.isDate ? true : false),
            isTimeInput: (this.isTime ? true : false),
            isDateTimeInput: (this.isDateTime ? true : false),
        }
    }, 
    methods: {
        inputFormatter(value) {
            if (this.thousandSeparator) {
                if (value != null && value != "" && value != undefined)
                    return value
                        .replace(/[^\d.-]/g, "")
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return "0";
            }
            return value;
        },
    },
    computed : {
        isAllowEdit : {
            get: function() {
                if (this.isEditable != undefined) return this.isEditable;
                else return true;
            }
        },
        isUseClassSameAsLabel : {
            get: function() {
                if (this.sameSizeLabelValue != undefined) return this.sameSizeLabelValue;
                else return true;
            }
        },
        useLabel() {
            if (this.nolabel != null && this.nolabel != undefined && this.nolabel != '') {
                if (this.nolabel) return false;
            }
            return true;
        }
    },
    watch : {
        model : function(val) {
            this.inputModel = val;
            if(val != undefined && val != null) {
                if(this.thousandSeparator) {
                    this.inputModel = this.inputFormatter(val.toString());
                } else if (this.isDateInput) {
                    let date = new Date(this.inputModel);
                    if (date) {
                        this.inputModel = moment(date).format('DD-MMM-YYYY');
                    }
                } else if (this.isTimeInput) {
                    let date = new Date(this.inputModel);
                    if (date) {
                        this.inputModel = moment(date).format('HH:mm');
                    }
                } else if (this.isDateTimeInput) {
                    let date = new Date(this.inputModel);
                    if (date) {
                        this.inputModel = moment(date).format('DD-MMM-YYYY HH:mm');
                    }
                }
            }
        },
        label : function(val) {
            this.labelStr = val;
        }
    },
	beforeMount() {
        if (this.model != undefined && this.model != null) {
            if (this.thousandSeparator) {
                this.inputModel = this.inputFormatter(this.model.toString());
            } else if (this.isDateInput) {
                let date = new Date(this.model.toString());
                if (date) {
                    this.inputModel = moment(date).format('DD-MMM-YYYY');
                }
            } else if (this.isTimeInput) {
                let date = new Date(this.model.toString());
                if (date) {
                    this.inputModel = moment(date).format('HH:mm');
                }
            } else if (this.isDateTimeInput) {
                let date = new Date(this.model.toString());
                if (date) {
                    this.inputModel = moment(date).format('DD-MMM-YYYY HH:mm');
                }
            }
        }
	},
}
</script>
<style scoped>
.input-group-text {
    font-size: 0.7rem !important;
}
</style>